








import FrameEdit from "@/components/products/framepuzzle/design/FrameEdit.vue"
import FrameEditBig from "@/components/products/framepuzzle/design/FrameEditBig.vue"
import FramePuzzle from "@/components/products/framepuzzle/design/FramePuzzle.vue"
import { FramePuzzleModule, PuzzleBoxState } from '@/store/modules/framePuzzle'
import { AppModule } from '@/store/modules/app'
import CartButton from "@/components/products/framepuzzle/util/CartButton.vue"

export default {
    name: "frame-puzzle-design",

    components: {
        FrameEdit,
        FrameEditBig,
        FramePuzzle,
        CartButton
    },
    computed: {
        showFrameEdit: function () {
            return FramePuzzleModule.showFrame || (AppModule.showMenu && FramePuzzleModule.frameStepComplete)
        },
        showPuzzle: function () {
            return FramePuzzleModule.showPuzzle || FramePuzzleModule.showImagePreview || (AppModule.showMenu && !FramePuzzleModule.frameStepComplete)
        }
    }
}
